import $ from 'jquery';
import daterangepicker from 'daterangepicker';
import moment from 'moment';
import { dateFormatInput, dateFormatOutput } from '@/const.js';
import { formatDate } from '@/util.js';

document.addEventListener('DOMContentLoaded', () => {
  window.datepickerInit()
})

window.datepickerInit = function () {
  let datepickers = $('.jsInputDate');

  datepickers.each(function (e) {

    let thisPicker = $(this).daterangepicker({
      locale: {
        format: dateFormatInput,
        separator: " - ",
        applyLabel: "Применить",
        cancelLabel: "Отмена",
        fromLabel: "От",
        toLabel: "До",
        customRangeLabel: "Custom",
        weekLabel: "W",
        daysOfWeek: [
          "Вс",
          "Пн",
          "Вт",
          "Ср",
          "Чт",
          "Пт",
          "Сб"
        ],
        monthNames: [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ],
        firstDay: 1
      },
      autoUpdateInput: false,
      linkedCalendars: false,
      buttonClasses: "button button--sm",
      applyButtonClasses: "",
      cancelClass: "button--light",
      // drops: "auto",
      opens: "center",
      parentEl: $(this).closest('.modal') ? $(this).closest('.modal-content') : $('body'),
    });

    thisPicker.on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));

      if ($(this).closest('.filter')) {
        $(this).closest('.filter').find('input[name="date_from"').val(picker.startDate.format(dateFormatOutput))
        $(this).closest('.filter').find('input[name="date_to"').val(picker.endDate.format(dateFormatOutput))
      }

      window.datepickerChange($(this)[0])
    });

    thisPicker.on('cancel.daterangepicker', function (ev, picker) {
      $(this).val('');

      if ($(this).closest('.filter')) {
        $(this).closest('.filter').find('input[name="date_from"').val('')
        $(this).closest('.filter').find('input[name="date_to"').val('')
      }

      window.datepickerChange($(this)[0])
    });
  })

  let datepickersSingle = $('.jsInputDateSingle');

  datepickersSingle.each(function (index, element) {
    let thisPicker = $(this).daterangepicker({
      locale: {
        format: dateFormatInput,
        separator: " - ",
        applyLabel: "Применить",
        cancelLabel: "Отмена",
        fromLabel: "От",
        toLabel: "До",
        customRangeLabel: "Custom",
        weekLabel: "W",
        daysOfWeek: [
          "Вс",
          "Пн",
          "Вт",
          "Ср",
          "Чт",
          "Пт",
          "Сб"
        ],
        monthNames: [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ],
        firstDay: 1
      },
      "singleDatePicker": true,
      autoUpdateInput: false,
      linkedCalendars: false,
      buttonClasses: "button button--sm",
      applyButtonClasses: "",
      cancelClass: "button--light",
      // drops: "auto",
      opens: "center",
      parentEl: $(this).closest('.modal') ? $(this).closest('.modal-content') : $('body'),
    });

    thisPicker.on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format(dateFormatOutput));
      window.inputStatusAdd(element, 'filled')

      if ($(this).closest('.filter')) {
        $(this).closest('.filter').find('input[name="date_from"').val(picker.startDate.format(dateFormatOutput))
      }

      window.datepickerChange(element)
    });

    thisPicker.on('cancel.daterangepicker', function (ev, picker) {
      $(this).val('');
      window.inputStatusRemove($(this)[0], 'filled')

      if ($(this).closest('.filter')) {
        $(this).closest('.filter').find('input[name="date_from"').val('')
      }


      window.datepickerChange($(this)[0])
    });

  })
};

const datepickerSetStartDate = (el, dateString) => {
  if (!el || !dateString) return false;

  const formattedDateString = formatDate(dateString);
  const formattedOutputDateString = formatDate(dateString, dateFormatOutput);
  $(el).val(formattedOutputDateString);
  $(el).data('daterangepicker').setStartDate(formattedDateString);
  $(el).data('daterangepicker').setEndDate(formattedDateString);

  return true;
};



window.datepickerSetStartDate = datepickerSetStartDate;
